import './style.scss';

import React from 'react';

export const ProBadge: React.FC = () => (
	<span className="redfox-thank-you-base-control__pro-badge">Pro</span>
);
